import React from 'react';
import { Row, Col } from 'reactstrap';

const CafOfferRow = ({ cafoffer }) => {
  if (!cafoffer) return null;

  return (
    <div>
      <Row>
        <Col md='1' className='white-border'>
          {cafoffer.productCode}
        </Col>
        <Col md='4' className='white-border'>
          {cafoffer.productDescription}
        </Col>
        <Col md='2' className='white-border'>
          {cafoffer.costLevel}
        </Col>
        <Col md='1' className='white-border'>
          {cafoffer.offerFunderId}
        </Col>
        <Col md='1' className='white-border'>
          {cafoffer.rebateAmount}
        </Col>
        <Col md='3' className='white-border'>
          {cafoffer.processMessages}
        </Col>
      </Row>
    </div>
  );
};

export default CafOfferRow;
